import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.window
import org.w3c.dom.events.Event

@JsExport
@StimulusController(values = ConfirmController.Values::class)
class ConfirmController(context: dynamic) : Controller(context) {
    private val message by messageValue()

    object Values { val message: String = "Are you sure?" }

    @JsName("confirm")
    fun confirm(event: Event) {
        if (!window.confirm(message)) event.preventDefault()
    }
}
